<div class="minimum-funding-box">
  <div class="icon-i-close-circle icon-color-red"></div>
  <div>
    <h4>{{ 'SHARED.projectMini.callout.title' | translate }}</h4>
    <p>
      {{ 'SHARED.projectMini.callout.description' | translate: { amount: minFundingAmount | translateNumber: language:currency } }}
    </p>
  </div>
  <button routerLink="/adjust-investment" class="ui-button" (click)="onShowAccountDetails()">
    {{ 'SHARED.projectMini.callout.link' | translate }}
  </button>
</div>
